/** Failed attempts below this count can retry immediately. */
export const PIN_LOCKOUT_THRESHOLD = 5

/** Escalating lockout after the threshold — seconds for each excess failure. */
export const PIN_LOCKOUT_DELAYS_SEC = [3, 5, 15, 30, 60, 120, 300] as const

export const getPinLockoutDelayMs = (failedAttempts: number): number => {
  if (failedAttempts < PIN_LOCKOUT_THRESHOLD) {
    return 0
  }

  const index = failedAttempts - PIN_LOCKOUT_THRESHOLD
  const delaySec =
    index < PIN_LOCKOUT_DELAYS_SEC.length
      ? PIN_LOCKOUT_DELAYS_SEC[index]
      : PIN_LOCKOUT_DELAYS_SEC[PIN_LOCKOUT_DELAYS_SEC.length - 1]

  return delaySec * 1000
}

export const getPinLockoutSecondsRemaining = (
  pinLockoutUntilMs: number,
  nowMs = Date.now()
): number => {
  if (pinLockoutUntilMs <= nowMs) {
    return 0
  }

  return Math.ceil((pinLockoutUntilMs - nowMs) / 1000)
}
